<div class="otp-verification-container container-fluid h-100">
  <div class="row">
    <div class="col-12">
      <a [href]="links.home">
        <om-logo class="mx-auto mt-5"></om-logo>
      </a>
    </div>
  </div>

  <div class="row text-center mb-4">
    <div class="col-10 offset-1 col-md-6 offset-md-3">
      <h1 class="mt-5">Enter confirmation code</h1>
      <p class="body p-0">Enter the verification code sent to {{ phoneNumber }}</p>
    </div>
  </div>

  <div class="row">
    <div class="col-10 offset-1 col-md-6 offset-md-3">
      <div class="form row">
        <div class="col">
          <form [formGroup]="otpForm" (ngSubmit)="onSubmit()">
            <div class="col-12 mb-4">
              <div class="otp-input-container">
                <input
                  type="text"
                  class="otp-input"
                  id="otp-0"
                  maxlength="1"
                  inputmode="numeric"
                  (keypress)="onKeyPress($event, 0)"
                  (keydown)="onKeyDown($event, 0)"
                  (paste)="onPaste($event)"
                />
                <input
                  type="text"
                  class="otp-input"
                  id="otp-1"
                  maxlength="1"
                  inputmode="numeric"
                  (keypress)="onKeyPress($event, 1)"
                  (keydown)="onKeyDown($event, 1)"
                  (paste)="onPaste($event)"
                />
                <input
                  type="text"
                  class="otp-input"
                  id="otp-2"
                  maxlength="1"
                  inputmode="numeric"
                  (keypress)="onKeyPress($event, 2)"
                  (keydown)="onKeyDown($event, 2)"
                  (paste)="onPaste($event)"
                />
                <input
                  type="text"
                  class="otp-input"
                  id="otp-3"
                  maxlength="1"
                  inputmode="numeric"
                  (keypress)="onKeyPress($event, 3)"
                  (keydown)="onKeyDown($event, 3)"
                  (paste)="onPaste($event)"
                />
                <input
                  type="text"
                  class="otp-input"
                  id="otp-4"
                  maxlength="1"
                  inputmode="numeric"
                  (keypress)="onKeyPress($event, 4)"
                  (keydown)="onKeyDown($event, 4)"
                  (paste)="onPaste($event)"
                />
                <input
                  type="text"
                  class="otp-input"
                  id="otp-5"
                  maxlength="1"
                  inputmode="numeric"
                  (keypress)="onKeyPress($event, 5)"
                  (keydown)="onKeyDown($event, 5)"
                  (paste)="onPaste($event)"
                />
              </div>
              <div *ngIf="errorMessage" class="text-danger mt-2 text-center">
                {{ errorMessage }}
              </div>
            </div>

            <div class="d-grid gap-3">
              <omgui-button
                [variant]="OmguiButtonVariant.primary"
                [size]="OmguiButtonSize.fillParent"
                [type]="OmguiButtonType.submit"
                [disabled]="isSubmitting"
              >
                <span *ngIf="!isSubmitting">Continue</span>
                <span *ngIf="isSubmitting">Processing...</span>
              </omgui-button>

              <om-back-button label="Back" (back)="onBack()"> </om-back-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
